
$(function(){
  
  function initDatePicker(){
    $('#datepicker').datepicker({
      dateFormat: 'yy年mm月dd日'
    });
  }
  
  setTimeout(function(){
    /*! jQuery UI - v1.10.4 - 2014-01-17
    * http://jqueryui.com
    * Copyright 2014 jQuery Foundation and other contributors; Licensed MIT */
  
    jQuery(function(t){t.datepicker.regional.ja={closeText:"閉じる",prevText:"&#x3C;前",nextText:"次&#x3E;",currentText:"今日",monthNames:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],monthNamesShort:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],dayNames:["日曜日","月曜日","火曜日","水曜日","木曜日","金曜日","土曜日"],dayNamesShort:["日","月","火","水","木","金","土"],dayNamesMin:["日","月","火","水","木","金","土"],weekHeader:"週",dateFormat:"yy/mm/dd",firstDay:0,isRTL:!1,showMonthAfterYear:!0,yearSuffix:"年"},t.datepicker.setDefaults(t.datepicker.regional.ja)});
    
    initDatePicker();
    
  },1000);
  
});
